export default "__VITE_ASSET__BZaa8xGO__"